import mathHelpers from '../helpers/math';
import Site from '../interfaces/ISite';
import Coords from '../interfaces/ICoords';

export interface NearbySite {
    site: Site;
    distanceInMeters: number | null; // same units as mathHelpers.distanceBetweenPoints
}

export const findNearestSites = (
    sites: Site[],
    location?: Coords,
    limit = 1
): NearbySite[] => {
    if (!sites?.length) return [];

    const take = Math.max(1, limit);

    if (!location) {
        // mirror old behavior but include distance as null
        return sites.slice(0, take).map(site => ({ site, distanceInMeters: null }));
    }

    const { latitude: lat, longitude: lon } = location;

    return sites
        .filter(s => s?.siteMetadata?.latitude != null && s?.siteMetadata?.longitude != null)
        .map(s => ({
            site: s,
            distanceInMeters: mathHelpers.distanceBetweenPoints(
                lat, lon, s.siteMetadata.latitude!, s.siteMetadata.longitude!
            ),
        }))
        .sort((a, b) => (a.distanceInMeters! - b.distanceInMeters!))
        .slice(0, take);
};
